var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2232_12923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.25 11C-0.25 17.2132 4.7868 22.25 11 22.25C17.2132 22.25 22.25 17.2132 22.25 11C22.25 4.7868 17.2132 -0.25 11 -0.25C4.7868 -0.25 -0.25 4.7868 -0.25 11Z",
    fill: "#08C108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 8.5L9.75 13.5L7.25 11M11 22.25C4.7868 22.25 -0.25 17.2132 -0.25 11C-0.25 4.7868 4.7868 -0.25 11 -0.25C17.2132 -0.25 22.25 4.7868 22.25 11C22.25 17.2132 17.2132 22.25 11 22.25Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2232_12923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.cc6bfa3b0dc1dde54b586f5157615fd8.svg";
export { ForwardRef as ReactComponent };